import React from 'react';
import { withRouter } from 'react-router';
import { RouterComponentProps } from '../../routes/interfaces';
import { compose } from 'recompose';

type InnerProps = RouterComponentProps;

const firstInfoStyles = 'color: #03A9F4; font-weight: bold';
const secondInfoStyles = 'color: #4CAF50; font-weight: bold';

class RouterDebugger extends React.PureComponent<InnerProps, {}> {
  // TODO: Figure out if can infer if route change came from <Redirect />, history.push or link
  componentDidUpdate(prevProps) {
    const prevRoute = prevProps.location.pathname;
    const currentRoute = this.props.location.pathname;

    console.log('');
    console.group(
      `%c Route Change: ${prevRoute} ~> ${currentRoute}`,
      'color: #898989;',
    );
    console.info('%c Current:', firstInfoStyles, this.props.location);
    console.info('%c Previous:', secondInfoStyles, prevProps.location);
    console.groupEnd();
    console.log('');
  }

  render() {
    return null;
  }
}

const enhance = compose<InnerProps, {}>(withRouter);

export default enhance(RouterDebugger);
